import { inject, Injectable } from "@angular/core";
import {
  catchError,
  firstValueFrom,
  forkJoin,
  Observable,
  of,
  tap,
} from "rxjs";
import { IAppConfig, SettingEnum } from "@models/core/setting";
import { APP_CONFIG } from "@tokens/application-config.token";
import { SettingsService } from "@dmms/core/http";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  private appConfig$ = inject(APP_CONFIG);

  public loadSettings(settingsService: SettingsService): Promise<IAppConfig> {
    return firstValueFrom(this.loadAppSettings(settingsService));
  }

  private loadAppSettings(
    settingsService: SettingsService,
  ): Observable<IAppConfig> {
    return forkJoin({
      applicationName: settingsService
        .getSettingByKey(SettingEnum.ApplicationName, "")
        .pipe(catchError(() => of(""))),
    }).pipe(
      tap(({ applicationName }) => {
        this.appConfig$.next({
          applicationName,
        });
      }),
    );
  }
}
